import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaGraduationCap, FaLock, FaUnlock } from 'react-icons/fa';

const navLinks = [
  { to: '/courses', label: 'Courses' },
  { to: '/notes', label: 'Notes' },
  { to: '/gallery', label: 'Gallery' },
  { to: '/videos', label: 'Videos' },
  { to: '/contact', label: 'Contact' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const notesUnlocked = sessionStorage.getItem('sbs_notes_unlocked') === 'true';

  return (
    <nav className="navbar">
      <Link to="/" className="navbar-brand" onClick={() => setOpen(false)}>
        <FaGraduationCap size={24} /> <span>SBS</span> Institute
      </Link>

      <ul className={`navbar-links ${open ? 'open' : ''}`}>
        {navLinks.map(({ to, label }) => {
          const isNotes = to === '/notes';
          const icon = isNotes ? (notesUnlocked ? <FaUnlock size={14} /> : <FaLock size={14} />) : null;
          
          return (
            <li key={to}>
              <Link
                to={to}
                className={pathname === to ? 'active' : ''}
                onClick={() => setOpen(false)}
                style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}
              >
                {icon} {label}
              </Link>
            </li>
          );
        })}
      </ul>

      <button className="hamburger" onClick={() => setOpen(o => !o)} aria-label="Toggle menu">
        <span /><span /><span />
      </button>
    </nav>
  );
}
